<template>
  <section id="tools" class="tools-section">
    <h2 class="section-title">Platform Suite</h2>
    
    <!-- 修改点 1: 遍历 visibleTools 而不是 tools -->
    <div class="tools-grid">
      <div v-for="(tool, index) in visibleTools" :key="tool.title" class="tool-card" ref="toolCards">
        <div class="tool-icon"><i :class="tool.icon"></i></div>
        <h3>{{ tool.title }}</h3>
        <p>{{ tool.description }}</p>
        <div class="tool-btn-container">
          <button class="tool-btn" @click="openToolModal(tool)">
            {{ tool.platformOptions ? 'Explore Tool' : 'Coming Soon' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 修改点 2: 新增展开/收起控制按钮区域 -->
    <div v-if="tools.length > 12" class="expand-container">
      <button class="expand-btn" @click="toggleExpand">
        <span>{{ isExpanded ? 'Show Less' : 'View All Tools' }}</span>
        <!-- 图标根据状态旋转 -->
        <i class="fas fa-chevron-down" :class="{ 'icon-rotated': isExpanded }"></i>
      </button>
    </div>

    <!-- 动态模态框 (保持原有逻辑不变) -->
    <div v-if="activeTool" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <button class="modal-close" @click="closeModal">
          <i class="fas fa-times"></i>
        </button>
        <div class="modal-header">
          <h3>{{ activeTool.title }} Information</h3>
        </div>
        <div class="modal-body">
          <p class="modal-description">
            <template v-if="activeTool.modalDescription">
              {{ activeTool.modalDescription }}
            </template>
            <template v-else>
              {{ activeTool.description }}
            </template>
          </p>

          <!-- 为DiOrion-ToolBox添加密码验证按钮 -->
          <button v-if="activeTool.title === 'DiOrion-ToolBox'" class="info-btn" @click.stop="showPasswordModal = true">
            <i class="fas fa-info-circle"></i>
          </button>

          <div v-if="activeTool.platformOptions" class="platform-options">
            <div v-for="(option, idx) in activeTool.platformOptions" :key="idx" class="platform-option">
              <h4>{{ option.title }}</h4>
              <div class="platform-links">
                <a v-if="link.isInternal" v-for="(link, linkIdx) in option.links" :key="linkIdx" href="#"
                  class="platform-link" @click.prevent="navigateTo(link.url)">
                  {{ link.name }}
                </a>
                <a v-if="!link.isInternal" v-for="(link, linkIdx) in option.links" :key="linkIdx" :href="link.url"
                  target="_blank" class="platform-link">
                  {{ link.name }}
                </a>
              </div>
              <p v-if="option.features" class="platform-features">{{ option.features }}</p>
            </div>
          </div>

          <div v-else-if="!activeTool.link" class="platform-options">
            <div class="platform-option">
              <h4>Status:</h4>
              <p class="platform-features">
                {{ activeTool.title }} is currently in development and will be available soon.
              </p>
            </div>
          </div>

          <!-- 密码输入弹窗 -->
          <div v-if="showPasswordModal" class="password-modal">
            <div class="password-content">
              <h4>Enter Access Password</h4>
              <input type="password" v-model="passwordInput" @keyup.enter="verifyPassword" class="password-input"
                placeholder="Enter password">
              <div class="password-actions">
                <button class="password-btn" @click="verifyPassword">Confirm</button>
                <button class="password-btn cancel" @click="showPasswordModal = false">Cancel</button>
              </div>
            </div>
          </div>

          <!-- 工具箱信息弹窗 -->
          <div v-if="showToolboxInfo" class="toolbox-info-popup">
            <div class="popup-content">
              <h4>DiOrion-ToolBox Features</h4>
              <p>DiOrion-ToolBox will include the following tools:</p>
              <ul>
                <!-- <li><a href="http://192.168.195.62:6081">Boltz-2</a></li> -->
                
                <!-- <li><a href="http://192.168.195.62:8010">CyclicPeptidesDesign</a></li> -->
                <!-- <li><a href="http://192.168.195.64:9084">DiOrion-PatChk (Multimodal Large Language Models)</a></li>
                <li><a href="http://192.168.195.65:5082">LLM-Dataset-Generation</a></li> -->
                <!-- <li><a href="http://192.168.195.65:8080">MLLM-DataLabeling</a></li> -->
                <li><a href="http://192.168.195.62:6083">BBB and CNS MPO Calculator</a></li>
                <li><a href="http://192.168.195.65:4004">Text-to-Image Generation</a></li>
                <li><a href="http://192.168.195.65:7860/">MinerU</a></li>
                <li><a href="http://192.168.195.65:5000">ExpOpt-V2.0</a></li>
              </ul>
              <button class="popup-close" @click="closeToolboxInfo">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PharmaDaily from './PharmaDaily.vue';

export default {
  data() {
    return {
      activeTool: null,
      showToolboxInfo: false,
      showPasswordModal: false,
      passwordInput: '',
      isExpanded: false, // 修改点 3: 新增展开状态控制
      tools: [
        {
          icon: "fa-solid fa-newspaper",
          title: "DiOrion-PharmaDaily",
          description: "Track the latest stock market trends, pharma news, and scientific insights to stay ahead in the fast-evolving biopharmaceutical industry.",
          modalDescription: "DiOrion-PharmaDaily provides real-time tracking of the latest stock market trends, curated pharma news, and cutting-edge scientific insights, equipping professionals to stay ahead in the fast-evolving biopharmaceutical industry.",
          platformOptions: [
            {
              title: "Access URL:",
              links: [
                {
                  name: "DiOrion-PharmaDaily",
                  url: "/pharma-daily",
                  isInternal: true
                }
              ],
              features: "categories include: Company Developments, FDA Approvals, Clinical Trials, Regulatory Policies, Financial News, and Market Trends."
            }
          ]
        },
        {
          icon: "fas fa-brain",
          title: "DiOrion-GPT",
          description: "An advanced intelligent agent designed to integrate and synergize diverse multimodal data, generating actionable, reliable, and efficient insights that expedite the initiation phase of the pharmaceutical R&D pipeline.",
          modalDescription: "DiOrion-GPT provides intelligent dialogue for rapid and efficient project research and analysis.",
          platformOptions: [
            {
              title: "Access Options:",
              links: [
                {
                  name: "DiOrion-GPT",
                  url: "http://192.168.195.64:8089",
                  isInternal: false
                },
                {
                  name: "DiOrion-GPT(Agent Version)",
                  url: "http://192.168.195.65:9107/",
                  isInternal: false
                },
                {
                  name: "RAG",
                  url: "http://192.168.195.150:4001/",
                  isInternal: false
                }
              ],
              features: "Internal version includes full features: DiOrion-GPT, visualSAR, PropEval, PatChk"
            }
          ]
        },
        {
          icon: "fas fa-dna",
          title: "DiOrion-MolGen",
          description: "Target-trained shape, electrostatic potential, and pharmacophore-aware reinforcement learning yields highly optimized small molecules beyond conventional AI drug design.",
          modalDescription: "Advanced AI engine for designing new drug molecules with improved effectiveness and easy synthesis.",
          platformOptions: [
            {
              title: "Access URL:",
              links: [
                {
                  name: "DiOrion-MolGen",
                  url: "http://192.168.195.62:7080/"
                },
                {
                  name: "DiOrion-LeadEvolution",
                  url: "http://192.168.195.65:6969/auth/login"
                },
                {
                  name: "DiOrion-MolEval",
                  url: "http://192.168.195.65:6002/auth/login"
                }
              ],
              features: "Generative AI molecular design"
            }
          ]
        },
        {
          icon: "fas fa-link",
          title: "DiOrion-PepGen",
          description: "MMS-driven analysis for non natural amino acid cyclic and linear peptide generation, enabling novel therapeutics beyond the limits of protein target based design",
          modalDescription: "Next-generation peptide drug design powered by AI",
          platformOptions: [
            {
              title: "Access URL:",
              links: [
                {
                  name: "DiOrion-PepGen",
                  url: "http://192.168.195.62:7082/"
                }
              ],
              features: "Design of Specialized Peptide Therapeutics"
            }
          ]
        },
        {
          icon: "fas fa-search",
          title: "DiOrion-MolExtract",
          description: "Intelligently and automatically extracts molecular structures and information from patents and articles.",
          modalDescription: "Intelligent molecular structure extraction from patents and scientific literature.",
          platformOptions: [
            {
              title: "Access URL:",
              links: [
                {
                  name: "DiOrion-MolExtract",
                  url: "http://192.168.195.150:3000/"
                }
              ],
              features: "Patent and article analysis tools"
            }
          ]
        },
        {
          icon: "fas fa-file-excel", 
          title: "DiOrion-MolExport",
          // 简短描述：突出了核心的转换与可视化功能
          description: "Converts SMILES-containing files into standardized Excel formats with visualizable and editable chemical structures.",
          
          // 详细描述：强调了批量处理、专业报表以及交互式编辑
          modalDescription: "An efficient molecular data processing tool that supports batch exporting SMILES strings into standardized Excel reports, featuring high-fidelity chemical structure visualization and interactive editing capabilities.",
          
          platformOptions: [
            {
              title: "Access URL:",
              links: [
                {
                  name: "DiOrion-MolEport",
                  url: "http://192.168.195.64:5173/"
                }
              ],
              // 核心功能点
              features: "SMILES-to-Excel conversion, Structure visualization, Interactive molecular editing"
            }
          ]
        },
        {
          icon: "fas fa-microscope",
          title: "DiOrion-ExpOpt",
          description: "A pioneering drug-design module that distills expert drug hunters' tacit knowledge into generalizable pharmaceutical principles, offering expert-level, actionable modification tactics.",
          modalDescription: "Experimental optimization system for drug design.",
          platformOptions: [
            {
              title: "Access URL:",
              links: [
                {
                  name: "DiOrion-ExpOpt",
                  url: "http://192.168.195.62:9082/"
                }
              ],
              features: "Optimization strategies for drug design."
            }
          ]
        },
        {
          icon: "fas fa-chart-line",
          title: "DiOrion-PropEval",
          description: "Multi-parameter optimization platform providing comprehensive ADME/T, and drug-likeness predictions using state-of-the-art machine learning models.",
          modalDescription: "Comprehensive property evaluation platform for ADME/T predictions and drug-likeness assessment.",
          platformOptions: [
            {
              title: "Access URL:",
              links: [
                {
                  name: "DiOrion-PropEval",
                  url: "http://192.168.195.64:9086/"
                },
                {
                  name: "DiOrion-AOPred",
                  url: "http://192.168.195.64:9087/"
                },
                {
                  name: "DiOrion-QSARBulid",
                  url: "http://192.168.195.65:5005/"
                }
              ],
              features: "Full property evaluation suite"
            }
          ]
        },
        {
          icon: "fas fa-project-diagram",
          title: "DiOrion-VisualSAR",
          description: "A sophisticated SAR analysis module powered by a versatile AI Agent, offering a rich suite of interactive visualization tools to unlock deep structure-activity relationship patterns.",
          modalDescription: "Interactive SAR analysis with R-group decomposition and activity cliff identification.",
          platformOptions: [
            {
              title: "Access URL:",
              links: [
                {
                  name: "DiOrion-VisualSAR",
                  url: "http://192.168.195.62:9081/"
                },
                {
                  name: "DiOrion-ScaffoldGraph",
                  url: "http://192.168.195.65:6003/"
                }
              ],
              features: "Structure-activity relationship visualization"
            }
          ]
        },
        {
          icon: "fas fa-shield-alt",
          title: "DiOrion-PatChk",
          description: "A groundbreaking patent check module powered by MLLM and medicinal chemistry insights, featuring deep Markush reasoning",
          modalDescription: "AI-driven freedom-to-operate analysis and patent landscape assessment.",
          platformOptions: [
            {
              title: "Access URL:",
              links: [
                {
                  name: "DiOrion-PatChk",
                  url: "http://192.168.195.64:9085/"
                }
              ],
              features: "Patent infringement risk evaluation"
            }
          ]
        },
        // {
        //   icon: "fas fa-filter",
        //   title: "DiOrion-VirtScreen",
        //   description: "A high-performance virtual screening engine powered by AI, designed to rapidly filter massive compound libraries and identify high-potential active candidates with superior accuracy.",
        //   // modalDescription: "Coming Soon - Stay Tuned!",
        //   platformOptions: [
        //     {
        //       title: "Access URL:",
        //       links: [
        //         {
        //           name: "DiOrion-VirtScreen",
        //           url: "http://192.168.195.65:5001/"
        //         }
        //       ],
        //       // features: "2D/3D molecular property calculation & evaluation"
        //     }
        //   ]
        // },
        // {
        //   icon: "fas fa-cubes",
        //   title: "DiOrion-MolEval",
        //   description: "A comprehensive molecular evaluation suite offering dual 2D/3D analysis capabilities, calculating physicochemical properties and conformational landscapes for thorough compound profiling.",
        //   modalDescription: "Integrated molecular assessment including 2D descriptors and 3D conformational analysis.",
        //   platformOptions: [
        //     {
        //       title: "Access URL:",
        //       links: [
        //         {
        //           name: "DiOrion-MolEval",
        //           url: "http://192.168.195.65:6002/"
        //         }
        //       ],
        //       features: "2D/3D molecular property calculation & evaluation"
        //     }
        //   ]
        // },
        //{
        //  icon: "fas fa-gears",
        //  title: "DiOrion-SysGuard",
        //  description: "A DevOps operations module integrating secure code repository management and real-time server monitoring to ensure platform stability and infrastructure health.",
        //  modalDescription: "Integrated DevOps hub featuring GitLab for version control and Netdata for system telemetry.",
        //  platformOptions: [
        //    {
        //      title: "Access Services:",
        //      links: [
        //        {
        //          name: "GitLab",
        //          url: "http://192.168.195.62:9088/"
        //        },
        //        {
        //          name: "Netdata",
        //          url: "http://192.168.195.64:19999/"
        //        },
        //        {
        //          name: "Grafana",
        //          url: "http://192.168.195.62:20000/"
        //        },
        //        {
        //          name: "AIDD-Ada6000 Server",
        //          url: "https://192.168.195.153/"
        //        },
        //        {
        //          name: "CADD-Ada5000 Server1",
        //          url: "https://192.168.195.154/"
        //        },
        //        {
        //          name: "CADD-Ada5000 Server2",
        //          url: "https://192.168.195.155/"
        //        }
        //      ],
        //      features: "Code Lifecycle Governance & Real-time Infrastructure Monitoring"
        //    }
        //  ]
        //},
        {
          icon: "fas fa-toolbox",
          title: "DiOrion-ToolBox",
          description: "A comprehensive bioinformatics toolkit for processing and supporting drug discovery research.",
          modalDescription: "Coming Soon - Stay Tuned!",
        },
        {
          icon: "fas fa-recycle",
          title: "DiOrion-TPDesign",
          description: "A PROTAC and molecular glue design module with dual conformation driven design to build complete ternary complexes and screen native conformations with high efficiency.",
          modalDescription: "Coming Soon - Stay Tuned!",
        },
        {
          icon: "fas fa-cut",
          title: "DiOrion-siRGen",
          description: "Precision RNA therapeutics design tool optimizing siRNA sequences for enhanced potency, specificity, and delivery while minimizing off-target effects.",
          modalDescription: "Coming Soon - Stay Tuned!",
        },
        {
          icon: "fas fa-bullseye",
          title: "DiOrion-TarHunter",
          description: "AI-powered target identification and validation platform predicting protein-drug interactions and uncovering novel therapeutic targets through multi-omics analysis.",
          modalDescription: "Coming Soon - Stay Tuned!",
        },
        
      ]
    };
  },

  computed: {
    // 修改点 4: 计算当前应该显示的工具
    visibleTools() {
      if (this.isExpanded) {
        return this.tools;
      }
      return this.tools.slice(0, 12);
    }
  },

  methods: {
    // 修改点 5: 切换展开/收起状态的方法
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
      // 如果是点击"收起"，则平滑滚动回到工具列表顶部，体验更好
      if (!this.isExpanded) {
        const toolsSection = document.getElementById('tools');
        if (toolsSection) {
          toolsSection.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },

    openPasswordModal() {
      this.showPasswordModal = true;
      this.passwordInput = '';
    },
    navigateTo(route) {
      this.closeModal();
      this.$router.push(route);
      window.scrollTo(0, 0);
    },
    verifyPassword() {
      if (this.passwordInput === 'prssh') {
        this.showPasswordModal = false;
        this.showToolboxInfo = true;
      } else {
        this.passwordInput = '';
        alert('Incorrect password! Please try again.');
      }
    },
    closeToolboxInfo() {
      this.showToolboxInfo = false;
    },
    openToolModal(tool) {
      this.activeTool = tool;
      document.body.style.overflow = 'hidden';
    },
    closeModal() {
      this.activeTool = null;
      this.showPasswordModal = false;
      this.showToolboxInfo = false;
      document.body.style.overflow = '';
    },
    setupScrollAnimations() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      }, { threshold: 0.15 });

      // 观察者逻辑需要在DOM更新后重新绑定，这里简化处理，
      // 在实际应用中如果卡片是动态增加的，可能需要nextTick
      if(this.$refs.toolCards) {
        this.$refs.toolCards.forEach(card => observer.observe(card));
      }
    }
  },
  
  // 监听visibleTools变化，确保新渲染的卡片也有动画效果
  watch: {
    visibleTools: {
      handler() {
        this.$nextTick(() => {
          this.setupScrollAnimations();
        });
      },
      deep: true
    }
  },

  mounted() {
    this.setupScrollAnimations();
  }
};
</script>

<style scoped>
/*原有样式*/
.info-btn {
  background: transparent;
  border: none;
  color: #ffffff;
  cursor: pointer;
  margin-left: 8px;
  font-size: 1.2em;
  opacity: 0.7;
  transition: opacity 0.3s;
  outline: none;
}
.info-btn:hover {
  opacity: 1;
  color: #2980b9;
}

/* 密码输入弹窗样式 */
.password-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}

.password-content {
  background: white;
  padding: 25px;
  border-radius: 10px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  position: relative;
}

.password-content h4 {
  margin-top: 0;
  color: #2c3e50;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  text-align: center;
}

.password-input {
  width: 100%;
  padding: 10px;
  margin: 15px 0;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.password-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.password-btn {
  padding: 8px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
  background-color: #3498db;
  color: white;
}

.password-btn:hover {
  background-color: #2980b9;
}

.password-btn.cancel {
  background-color: #ecf0f1;
  color: #7f8c8d;
}

.password-btn.cancel:hover {
  background-color: #dfe6e9;
}

/* 工具箱信息弹窗样式 */
.toolbox-info-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.popup-content {
  background: white;
  padding: 25px;
  border-radius: 10px;
  max-width: 600px;
  width: 90%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  position: relative;
}

.popup-content h4 {
  margin-top: 0;
  color: #2c3e50;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.popup-content ul {
  padding-left: 20px;
  margin: 15px 0;
}

.popup-content li {
  margin-bottom: 8px;
  line-height: 1.4;
}

.popup-close {
  background: #3498db;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 4px;
  cursor: pointer;
  float: right;
  margin-top: 10px;
}

.popup-close:hover {
  background: #2980b9;
}

.platform-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px 0;
}

.platform-link {
  display: block;
  padding: 8px 12px;
  background-color: #f0f7ff;
  border: 1px solid #c2d9ff;
  border-radius: 4px;
  color: #1a73e8;
  text-decoration: none;
  transition: all 0.3s ease;
}

.platform-link:hover {
  background-color: #e1ecff;
  border-color: #a8c7fa;
  text-decoration: underline;
}

/* =========================================
   修改点 6: 新增展开按钮和动画样式
   ========================================= */

.expand-container {
  display: flex;
  justify-content: center;
  margin-top: 50px;
  margin-bottom: 30px;
  position: relative;
  width: 100%;
}

/* 装饰线 - 调整为深色微光 */
.expand-container::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 10%;
  right: 10%;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(0, 242, 254, 0.2), transparent);
  z-index: 0;
}

/* === 核心按钮样式 === */
.expand-btn {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 40px;
  
  /* 背景：深色半透明玻璃 */
  background: rgba(12, 20, 40, 0.7);
  backdrop-filter: blur(5px);
  
  /* 边框：青色细边 */
  border: 1px solid rgba(64, 224, 208, 0.5); /* 类似你图标的青绿色 */
  border-radius: 50px;
  
  /* 文字颜色：青白色 */
  color: #40e0d0; 
  font-family: 'Segoe UI', sans-serif; /* 确保字体也匹配 */
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.5px;
  
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

/* 悬停效果：发光 + 变亮 */
.expand-btn:hover {
  background: rgba(64, 224, 208, 0.15); /* 淡淡的青色背景 */
  border-color: #40e0d0;
  color: #ffffff; /* 文字变白 */
  box-shadow: 0 0 20px rgba(64, 224, 208, 0.4), inset 0 0 10px rgba(64, 224, 208, 0.2);
  transform: translateY(-2px);
  text-shadow: 0 0 8px rgba(64, 224, 208, 0.6);
}

/* 点击效果 */
.expand-btn:active {
  transform: translateY(0);
  box-shadow: 0 0 5px rgba(64, 224, 208, 0.4);
}

/* 图标样式 */
.expand-btn i {
  font-size: 14px;
  transition: transform 0.4s ease;
}

.icon-rotated {
  transform: rotate(180deg);
}

/* 卡片淡入动画，使展开过程更流畅 */
.tools-grid .tool-card {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>

